import React, { useEffect, useState } from 'react';
import { getServices, deleteServices } from '~/services/hooks/services';
import Box from '~/components/Box';
import { Table, TableHeader } from '~/components/Table';
import { Col, Input, message } from 'antd';
import Pagination from '~/components/Pagination';
import { useTranslation } from 'react-i18next';
import Button from '~/components/Button';
import ServicesModal from './form';
import { useCheckAuth } from '~/components/Can/checkAuth';
import ColButton from '~/components/ColButton';
import IsMobile from '~/services/mobileCheck';
import { servicesColumns } from '~/tables/services';
import errorHandler from '~/Utils/errorHandler';

export default function Services() {
  const { t } = useTranslation();
  const authCheck = useCheckAuth();
  const isMobile = IsMobile();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});
  const [search, setSearch] = useState('');
  const [servicesEdit, setServicesEdit] = useState({});
  const [ModalVisible, setModalVisible] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          perPage,
          search,
        },
      };
      const data = await getServices(params);
      setData(data.data);
      setMeta(data.meta);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleEdit = (record) => {
    setServicesEdit(record);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await deleteServices(id);
      message.success(t('Serviço excluído'));
      fetchData();
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, perPage, search]);

  return (
    <Box>
      <ColButton>
        <Button color="primary" onClick={() => handleEdit(null)} disabled={!authCheck('@services/create')}>
          {t('Adicionar serviço')}
        </Button>
      </ColButton>
      <TableHeader>
        <Col style={{ display: 'flex' }}>
          <Input.Search
            onSearch={(value) => {
              setSearch(value);
              setPage(1);
            }}
            className="search-field"
            placeholder={t('screens:default.search')}
          />
        </Col>
      </TableHeader>
      <Table
        pagination={false}
        rowKey="id"
        loading={loading}
        dataSource={data}
        columns={servicesColumns(handleEdit, handleDelete, isMobile)}
        bordered
      />
      <Pagination
        isMobile={isMobile}
        onChange={(value) => {
          setPage(value);
        }}
        meta={meta}
        perPage={perPage}
        setPerPage={setPerPage}
      />
      <ServicesModal
        visible={ModalVisible}
        servicesEdit={servicesEdit}
        isMobile={isMobile}
        onClose={() => {
          setModalVisible(false);
          setServicesEdit(null);
          fetchData();
        }}
      />
    </Box>
  );
}
